var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fafafa;}.cls-2{fill:#0071ce;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.5,
    y: 56,
    width: 1165,
    height: 1165,
    rx: 12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PANETONE_285",
    "data-name": "PANETONE 285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1101.9.3H178a178,178,0,0,0-178,178V1102a178,178,0,0,0,178,178H1101.9a178,178,0,0,0,178-178V178.32A178,178,0,0,0,1101.9.3ZM1198,1102a96.1,96.1,0,0,1-96.1,96.11H178A96.11,96.11,0,0,1,81.9,1102V178.32A96.12,96.12,0,0,1,178,82.2H1101.9A96.12,96.12,0,0,1,1198,178.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.21,331.78H337.14c-54.9,0-99.82,44.92-99.82,99.82V675.53c0,54.9,44.92,99.82,99.82,99.82h82.63V794c-1.06,45.17-26.92,71.44-89.23,72.59H291.29v81.87h39.25c115.6,0,180.75-54.71,182.68-155.06V331.78ZM420,694.31H365.86A35.32,35.32,0,0,1,330.54,659V448a35.32,35.32,0,0,1,35.32-35.32H420Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M942.77,331.78H584V775.35H677.2V412.71h89.47V775.35h93.22V412.71h54.16A35.32,35.32,0,0,1,949.37,448V775.35h93.22V431.6C1042.59,376.7,997.67,331.78,942.77,331.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 583.98,
    y: 866.56,
    width: 458.61,
    height: 81.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d5659f1eaa3b8b9022721dcc1a30640b.svg";
export { ForwardRef as ReactComponent };